import React, { Component } from 'react'
import { connect } from 'react-redux'
import Forms from './Forms'
import { Row, Col } from 'antd'
import { downloadLaravelFile } from 'lib/laravelAuth'
import Breadcrumb from './../../../shared/components/Breadcrumbreport'
import { GeneralStyledContent } from '../../../../styled/common-styled'
import AuthorizeComponent from './../../../auth/components/AuthorizeComponent'
import moment from 'moment'

class Index extends Component {
  state = {
    partner: [],
    loading: false,
  }

  componentDidMount() {
    this.loadPartner()
  }

  loadPartner = () => {
    let self = this
    this.setState({ loading: true })
    fetch(`${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getpartnercompany`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.props.auth.accessToken}`,
      },
      body: JSON.stringify({
        company_id: this.props.auth.profile.company_id,
        is_gps_vendor: this.props.auth.profile.is_gps_vendor,
      }),
    })
      .then(response => response.json())
      .then(res => {
        self.setState({ partner: res.data, loading: false })
      })
      .catch(e => this.setState({ loading: false }))
  }

  onSubmit = value => {
    let self = this
    const { partner_list, eventdate, sortBy } = value
    const date_start = moment(eventdate['_d']).format('YYYY-MM-01')
    const date_end = moment(eventdate['_d']).format('YYYY-MM-31')
    this.setState({ loading: true })
    fetch(
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/report/partnerperform`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.props.auth.accessToken}`,
        },
        body: JSON.stringify({
          date_start,
          date_end,
          partner_list,
          sort_by: sortBy,
          vehicle_visibility: this.props.auth.profile.vehicle_visibility,
          type_file: 'excel',
        }),
      },
    )
      .then(response => response.json())
      .then(res => {
        self.setState({ loading: false }, () =>
          downloadLaravelFile(res.data).catch(e => console.error(e)),
        )
      })
      .catch(e => this.setState({ loading: false }))
  }

  render() {
    return (
      <AuthorizeComponent {...this.props} matching_name="partnerPerformReport">
        <GeneralStyledContent>
          <Row gutter={24}>
            <Col span={24}>
              {/* <Breadcrumb
                match={this.props.match}
                sub_menu="maintenancedevice"
                style={{ margin: "0px 0px 14px 10px" }}
              /> */}
            </Col>
          </Row>
          <Forms
            loading={this.state.loading}
            onSubmit={this.onSubmit}
            partnerLists={this.state.partner}
            loadPartner={this.loadPartner}
            onCriteriaChange={this.onCriteriaChange}
            auth={this.props.auth}
          />
        </GeneralStyledContent>
      </AuthorizeComponent>
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  auth,
})

// const mapDispatchToProps = {
//   loadAlarmAlertByPlateno: actions.loadAlarmAlertByPlateno.request
// };

// export default connect(mapStateToProps, mapDispatchToProps)(Index);
export default connect(mapStateToProps, null)(Index)
